import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  dismissStaffNotification,
  getUnreadStaffNotificationCount,
  listStaffNotifications,
  markStaffNotificationRead,
} from '@/features/notifications/api/staff-notifications.http.js';
import { staffNotificationKeys } from '@/features/notifications/query-keys.js';

export function useStaffNotifications(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: staffNotificationKeys.list(),
    queryFn: () => listStaffNotifications({ limit: 30 }),
    enabled: options?.enabled ?? true,
  });
}

export function useStaffUnreadNotificationCount(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: staffNotificationKeys.unreadCount(),
    queryFn: () => getUnreadStaffNotificationCount(),
    enabled: options?.enabled ?? true,
  });
}

export function useMarkStaffNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string) => markStaffNotificationRead(notificationId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: staffNotificationKeys.all });
    },
  });
}

export function useDismissStaffNotification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string) => dismissStaffNotification(notificationId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: staffNotificationKeys.all });
    },
  });
}
